import React from 'react';
import ReportManagement from '../../components/student/ReportManagement/ReportManagement';
import FacultyReportsList from '../../components/faculty/FacultyReportsList/FacultyReportsList';
import { useAuth } from '../../contexts/AuthContext';

const Reports = () => {
  const { user } = useAuth();
  
  // Render the appropriate component based on user role
  if (user.role === 'faculty') {
    return <FacultyReportsList />;
  }
  
  // Default to student report management
  return <ReportManagement />;
};

export default Reports;